import { render, staticRenderFns } from "./PaketDetail.vue?vue&type=template&id=8a1d0f76&scoped=true"
import script from "./PaketDetail.vue?vue&type=script&lang=js"
export * from "./PaketDetail.vue?vue&type=script&lang=js"
import style0 from "./PaketDetail.vue?vue&type=style&index=0&id=8a1d0f76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a1d0f76",
  null
  
)

export default component.exports